"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class ImageModule extends base_1.LabeledModule {
    constructor(_a) {
        var { src } = _a, rest = __rest(_a, ["src"]);
        super(rest);
        this._type = "image";
        this._src = src;
    }
    get src() {
        return this._src;
    }
    set src(src) {
        var _a;
        if (!(src === null || src === void 0 ? void 0 : src[this.languageCode]) ||
            !(0, util_1.isValidUrl)((_a = src === null || src === void 0 ? void 0 : src[this.languageCode]) !== null && _a !== void 0 ? _a : "")) {
            throw new Error(`invalid url provided for src: ${src}`);
        }
        this._src = src;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                id: this.id,
                src: this.src,
                label: this.label,
                style: this.style,
                type: this.type,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                id: this.id,
                src: this.src[this.languageCode],
                style: this.style,
                type: this.type,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        var _a, _b;
        if (this.validate()) {
            return {
                id: this.id,
                image: { src: (_a = this.src[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
                type: this.type,
                question: (_b = this.label[this.languageCode]) !== null && _b !== void 0 ? _b : "",
                actionRequired: this.actionRequired,
            };
        }
    }
}
exports.ImageModule = ImageModule;
//# sourceMappingURL=Image.js.map